import { useEffect, useState } from "react";

export function useUrlChangeListener() {
  const getLocationLikeObject = () => ({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: null, 
    key: Date.now().toString(), 
  });

  const [location, setLocation] = useState(getLocationLikeObject());

  useEffect(() => {
    const updateLocation = () => setLocation(getLocationLikeObject());

    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function (...args) {
      originalPushState.apply(this, args);
      updateLocation();
    };

    window.history.replaceState = function (...args) {
      originalReplaceState.apply(this, args);
      updateLocation();
    };

    window.addEventListener("popstate", updateLocation);

    return () => {
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
      window.removeEventListener("popstate", updateLocation);
    };
  }, []);

  return location;
}
